import { AutologinComponent } from './autologin/autologin.component';
import { ConfirmRetourComponent } from './recharge-sans-inscription/retour-recharge-sans-inscription/confirm-retour/confirm-retour.component';
import { RechargeSansInscriptionComponent } from './recharge-sans-inscription/recharge-sans-inscription.component';
import { CommunauteComponent } from './offline/communaute/communaute.component';
import { InformerComponent } from './offline/informer/informer.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {  LoginPageComponent} from './login-page/login-page.component';
import {  OfflineHomePageComponent} from './offline-home-page/offline-home-page.component';
import {  OfflineHeadImgComponent} from './offline-head-img/offline-head-img.component';
import {  LeafletMapComponent} from './leaflet-map/leaflet-map.component';
import {  OfflineCardPresentationComponent} from './offline-card-presentation/offline-card-presentation.component';
import {  BasicAutopartageComponent} from './basic-autopartage/basic-autopartage.component';
import { LoginHomePageComponent} from "./login-home-page/login-home-page.component";
import {  AuthGuardServiceService as AuthGuard} from './services/auth-guard-service.service';
import {  AutopartageComponent} from './auth/autopartage/autopartage.component';
import { BookConfirmationComponent} from './book/book-confirmation/book-confirmation.component';
import {  UserDashboardComponent} from './book/user-dashboard/user-dashboard.component';
import { BookDetailComponent} from './auth/book-detail/book-detail.component';
import { BookListPageComponent} from './auth/book/book-list-page/book-list-page.component';
import {  BasicPageComponent as BasicRechargePageComponent,  BasicPageComponent} from './recharge/basic-page/basic-page.component';
import { UserProfilComponent} from './auth/user/user-profil/user-profil.component';
import { BasicServiceComponent} from './service/basic-service/basic-service.component';
import {  PagecreatorComponent} from './pageCreator/pagecreator/pagecreator.component';
import { LostPasswordComponent} from './login/lost-password/lost-password.component';
import {  ResetPasswordComponent} from './reset-password/reset-password.component';
import {  LoginBaseComponent} from './loginPage/login-base/login-base.component';
import { UserFormulaComponent } from './user/user-formula/user-formula.component';
import { BookEcoBilanComponent } from './auth/book/book-eco-bilan/book-eco-bilan.component';
import { EcoBilanResumeComponent } from './auth/dashboard-block/eco-bilan-resume/eco-bilan-resume.component';
import { UserEcoComponent } from './user/user-eco/user-eco.component';
import { UserEditProfilComponent } from './user/user-edit-profil/user-edit-profil.component';
import { UserEditPasswordComponent } from './user/user-edit-password/user-edit-password.component';
import { CguComponent } from './informations-legales/cgu/cgu.component';
import { MentionLegalesComponent } from './informations-legales/mention-legales/mention-legales.component';
import { PolitiqueConfidentialiteComponent } from './informations-legales/politique-confidentialite/politique-confidentialite.component';
import { FaqComponent } from './informations-legales/faq/faq.component';
import { PaymentRechargeSansInscriptionComponent } from './recharge-sans-inscription/payment-recharge-sans-inscription/payment-recharge-sans-inscription.component';
import { ConfirmPaymentRechargeSansInscriptionComponent } from './recharge-sans-inscription/payment-recharge-sans-inscription/confirm-payment-recharge-sans-inscription/confirm-payment-recharge-sans-inscription.component';
import { RetourRechargeSansInscriptionComponent } from './recharge-sans-inscription/retour-recharge-sans-inscription/retour-recharge-sans-inscription.component';
import { CovoiturageComponent } from './auth/covoiturage/covoiturage.component';
import { ConsommationsComponent } from './auth/consommations/consommations.component';
import { RefreshTokenComponent } from './auth/refresh-token/refresh-token.component';





const routes: Routes = [
  // { path: '**', component: BookConfirmationComponent },

  {
    path: 'connexion',
    component: LoginBaseComponent,
    children: [{
        path: '',
        component: LoginPageComponent
      },
      {
        path: 'lost-password',
        component: LostPasswordComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      }
    ]
  },
  {
    path: 'creator',
    component: PagecreatorComponent
  },

  {
    path: 'user',
    component: UserProfilComponent
  },
  {
    path: 'refresh-token',
    component: RefreshTokenComponent
  },
  {
    path: 'covoiturage',
    component: CovoiturageComponent
  },
  {
    path: 'user-edit',
    component: UserEditProfilComponent
  },
  {
    path: 'user-password-edit',
    component: UserEditPasswordComponent
  },

  
  {
    path: 'auth',
    component: LoginHomePageComponent,
    canActivate: [AuthGuard],
    children: [{
        path: 'tableau-de-bord',
        component: UserDashboardComponent
      },
      {
        path: 'reservation/:id',
        component: BookDetailComponent
      },
      {
        path: 'reservations',
        component: BookListPageComponent
      },
      {
        path: 'autopartage',
        component: AutopartageComponent
      },
      {
        path: 'recharge',
        component: LoginPageComponent
      },
      {
        path: 'partage-trajet',
        component: LoginPageComponent
      },
      {
        path: 'ma-formule',
        component: UserFormulaComponent
      },
      {
        path: 'consommations',
        component: ConsommationsComponent
      },
      {
        path: 'mon-bilan-carbone',
        component: EcoBilanResumeComponent 
      },
      {
        path: 'mes-paiements',
        component: UserEcoComponent
      }

    ],
  },
  {
    path: '',
    component: BasicServiceComponent,
    children: [{
        path: '',
        component: BasicAutopartageComponent,
        data: {
          service: "autopartage",
        },
        children: [{
          path: '',
          component: AutopartageComponent
        }, ]
      },
      {
        path: 'autopartage',
        component: BasicAutopartageComponent,
        data: {
          service: "autopartage",
        },
        children: [{
          path: '',
          component: AutopartageComponent
        }, ]
      },
      {
        path: 'recharge',
        data: {
          service: "recharge",
        },
        component: BasicPageComponent,
        children: [{
          path: '',
          component: BasicRechargePageComponent
        }, ]
      },
      {
        path: 'velo',
        data: {
          service: "velo",
        },
        component: BasicAutopartageComponent,
        children: [{
          path: '',
          component: BasicAutopartageComponent
        }, ]
      },
      {
        path: 'partage-trajet',
        data: {
          service: "partage",
        },
        component: BasicAutopartageComponent
      }

    ],
  },
  {
    path: 'admin/subscribe',
    component: SubscribeComponent
  },
  {
    path: 'inquire',
    component: InformerComponent
  },
  {
    path: 'communaute',
    component: CommunauteComponent
  },
  {
    data: { service: "recharge"},
    path: 'recharge-sans-inscription/:guid/:idpl',
    component: RechargeSansInscriptionComponent
  },
  {
    path: 'payment',
    data: { service: "recharge"},
    component: PaymentRechargeSansInscriptionComponent
  },
  {
    path: 'payment/confirm',
    data: { service: "recharge"},
    component: ConfirmPaymentRechargeSansInscriptionComponent
  },
  {
    path: 'retour/recharge-sans-inscription',
    data: { service: "recharge"},
    component: RetourRechargeSansInscriptionComponent
  },
  {
    path: 'retour/confirm',
    data: { service: "recharge"},
    component: ConfirmRetourComponent
  },
  {
    path: 'cgu',
    component: CguComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'mention-legales',
    component: MentionLegalesComponent
  },
  {
    path: 'politique-de-confidentialite',
    component: PolitiqueConfidentialiteComponent
  },
  {
    path: 'autologin',
    component: AutologinComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
